import { IFoCaAnTruongSaveRequest } from "../../../api/dich-vu/food/foCaAnTruongApi";
import { fo_caan } from "../../../models/response/dich-vu/food/fo_caan";
import { FoCaAnTruongItemResponse } from "../../../models/response/dich-vu/food/fo_caan_truong";
import {
	eFoCaAnTruongActionTypeIds,
	IFoCaAnLoadErr,
	IFoCaAnLoadStart,
	IFoCaAnLoadSuccess,
	IFoCaAnTruongChangeSelectedIds,
	IFoCaAnTruongCloseConfirm,
	IFoCaAnTruongCloseDetail,
	IFoCaAnTruongDeleteErr,
	IFoCaAnTruongDeleteStart,
	IFoCaAnTruongDeleteSuccess,
	IFoCaAnTruongLoadErr,
	IFoCaAnTruongLoadStart,
	IFoCaAnTruongLoadSuccess,
	IFoCaAnTruongSaveErr,
	IFoCaAnTruongSaveStart,
	IFoCaAnTruongSaveSuccess,
	IFoCaAnTruongShowConfirm,
	IFoCaAnTruongShowDetail
} from "../../action-types/dich-vu/IFoCaAnTruongActionTypes";

export const foCaAnTruongActions = {
	loadFoCaAnTruongStart: (dm_coso_id: number): IFoCaAnTruongLoadStart => {
		return {
			type: eFoCaAnTruongActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadFoCaAnTruongSuccess: (data: FoCaAnTruongItemResponse[]): IFoCaAnTruongLoadSuccess => {
		return {
			type: eFoCaAnTruongActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadFoCaAnTruongError: (message: string): IFoCaAnTruongLoadErr => {
		return {
			type: eFoCaAnTruongActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadFoCaAnStart: (): IFoCaAnLoadStart => {
		return {
			type: eFoCaAnTruongActionTypeIds.LOAD_CAAN_START
		}
	},
	loadFoCaAnSuccess: (data: fo_caan[]): IFoCaAnLoadSuccess => {
		return {
			type: eFoCaAnTruongActionTypeIds.LOAD_CAAN_SUCCESS,
			payload: data
		}
	},
	loadFoCaAnError: (message: string): IFoCaAnLoadErr => {
		return {
			type: eFoCaAnTruongActionTypeIds.LOAD_CAAN_ERROR,
			payload: message
		}
	},
	showFoCaAnTruongDetail: (data?: IFoCaAnTruongSaveRequest): IFoCaAnTruongShowDetail => {
		return {
			type: eFoCaAnTruongActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeFoCaAnTruongDetail: (): IFoCaAnTruongCloseDetail => {
		return {
			type: eFoCaAnTruongActionTypeIds.CLOSE_DETAIL
		}
	},
	changeFoCaAnTruongSelectedIds: (ids: number[]): IFoCaAnTruongChangeSelectedIds => {
		return {
			type: eFoCaAnTruongActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showFoCaAnTruongConfirm: (): IFoCaAnTruongShowConfirm => {
		return {
			type: eFoCaAnTruongActionTypeIds.SHOW_CONFIRM
		}
	},
	closeFoCaAnTruongConfirm: (): IFoCaAnTruongCloseConfirm => {
		return {
			type: eFoCaAnTruongActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveFoCaAnTruongStart: (data: IFoCaAnTruongSaveRequest): IFoCaAnTruongSaveStart => {
		return {
			type: eFoCaAnTruongActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveFoCaAnTruongSuccess: (is_update: boolean): IFoCaAnTruongSaveSuccess => {
		return {
			type: eFoCaAnTruongActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveFoCaAnTruongError: (message: string): IFoCaAnTruongSaveErr => {
		return {
			type: eFoCaAnTruongActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteFoCaAnTruongStart: (ids: number[]): IFoCaAnTruongDeleteStart => {
		return {
			type: eFoCaAnTruongActionTypeIds.DELETE_START,
			payload: ids
		}
	},
	deleteFoCaAnTruongSuccess: (): IFoCaAnTruongDeleteSuccess => {
		return {
			type: eFoCaAnTruongActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteFoCaAnTruongError: (message: string): IFoCaAnTruongDeleteErr => {
		return {
			type: eFoCaAnTruongActionTypeIds.DELETE_ERROR,
			payload: message
		}
	}
}
